// Utils
import GridAction from '../../components/common/GridAction';
import { AppPermissions } from '../../constants/Permissions';
import { dateHeader, formatCellDate } from './timeModeCell';

// Types
import { CompanyRelation } from '../../types/Company';

export const makeCompanyRelationColumns = (onEdit: (relation: CompanyRelation) => void, onDelete: (relation: CompanyRelation) => void) => {
  const cols = [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 75,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return (
          <GridAction
            onEdit={() => onEdit(row.original)}
            editPermission={AppPermissions.Company.CompanyRelations.Read}
            onDeleted={() => onDelete(row.original)}
            deletePermission={AppPermissions.Company.CompanyRelations.Delete}
            row={row.original}
            id={row.original.id}
          />
        );
      },
    },
    {
      header: 'Full Name',
      accessorKey: 'fullName',
      size: 200,
      cell: ({ row }: { row: { original: CompanyRelation } }) => <span style={{ fontWeight: 500 }}>{row.original.fullName}</span>,
    },
    {
      header: 'First Name',
      accessorKey: 'firstName',
      size: 150,
    },
    {
      header: 'Last Name',
      accessorKey: 'lastName',
      size: 150,
    },
    {
      header: 'Email',
      accessorKey: 'email',
      size: 200,
    },
    {
      header: 'Phone',
      accessorKey: 'phone',
      size: 150,
    },
    {
      header: 'Job Description',
      accessorKey: 'jobDescription',
      size: 250,
    },
    {
      header: 'Station IATA Code',
      accessorKey: 'stationIataCode',
      size: 150,
      cell: ({ row }) => {
        const stations = row.original?.stations;
        if (!stations || stations.length === 0) return '';
        return stations.map((s) => s.displayName).join(', ');
      },
    },
    {
      header: 'Transfer Contact',
      accessorKey: 'isTransferContact',
      size: 120,
      cell: ({ row }: { row: { original: CompanyRelation } }) => (row.original.isTransferContact ? 'Yes' : 'No'),
    },
    {
      header: 'Reader Contact',
      accessorKey: 'isReaderContact',
      size: 120,
      cell: ({ row }: { row: { original: CompanyRelation } }) => (row.original.isReaderContact ? 'Yes' : 'No'),
    },
    {
      header: 'Scan Report Contact',
      accessorKey: 'isScanReportContact',
      size: 160,
      cell: ({ row }: { row: { original: CompanyRelation } }) => (row.original.isScanReportContact ? 'Yes' : 'No'),
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 150,
      cell: ({ row, table }: { row: { original: CompanyRelation }; table: any }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 150,
      cell: ({ row, table }: { row: { original: CompanyRelation }; table: any }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ];

  return cols;
};
